import { __makeTemplateObject } from "tslib";
import { css } from '../../../../foundation';
export var DialogContentTextStyle = function (_a) {
    var gutterBottom = _a.gutterBottom;
    // that is mui but, that not work with gutterBottom set
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), gutterBottom === false && 0);
};
var templateObject_1;
